import React from 'react';
import { Layout } from '../components/layout/Layout';
import OnboardingTour from '../components/common/OnboardingTour';
import { Hero, Founders, TrustBand, HowItWorks, NearYou } from '../components/home/HomeSections';

export default function HomePage() {
  return (
    <Layout>
      <OnboardingTour />
      <div className="bg-white" data-testid="home-page">
        <Hero />
        <Founders />
        <TrustBand />
        <HowItWorks />
        <NearYou />
      </div>
    </Layout>
  );
}
